import { setWorkspaceDirtyLabels } from './workspaceDirtyRegistry';

let activeLabels: string[] = [];

export const setActiveCalendarDirtyLabels = (labels: string[]): void => {
  activeLabels = labels;
  setWorkspaceDirtyLabels('calendar', labels);
};

export const confirmCalendarDirtyTransition = (): boolean => activeLabels.length === 0
  || window.confirm(`Discard unsaved ${activeLabels.join(', ')}?`);
